import { Campaign } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { convertObjectUpdateToFieldMaskPaths } from '@frontend/schema-field-mask';

export const createUpdateMask = (lastSavedCampaign: Campaign | undefined, updatedCampaign: Campaign) => {
  const { campaignId, type, ...sanitizedUpdatedCampaign } = updatedCampaign;
  const paths = convertObjectUpdateToFieldMaskPaths(
    { campaign: lastSavedCampaign },
    { campaign: sanitizedUpdatedCampaign },
    {
      filter: 'remove-nullish',
    }
  );

  return {
    paths,
    toJSON: () => paths.join(','),
  };
};
